import { createWebPlatform } from './web'
import type { PlatformAdapter } from './types'

/* Spec PWA-001 — selecao da plataforma em runtime. Hoje so web; a implementacao nativa (Capacitor)
   entra aqui na spec de empacotamento, sem alterar telas. */
export const platform: PlatformAdapter = createWebPlatform()

export type { PlatformAdapter, InstallAvailability, ShareResult } from './types'
